import React from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "../components/Dropdown";

const DropdownFilter = ({ dimension = [], onChange = () => {}, setIsActive = () => {}, allowDeleteDimension = true, clearFilter = () => {}, deleteDimension = () => {}  }) => {
    const { t } = useTranslation();

    return (
        <div className="rounded-md p-4 bg-white flex gap-4 flex-col w-[20rem] max-w-full">
            {dimension.map((filterItem, index) => {
                const displayLabel = t(`filter.${filterItem.label}`, { defaultValue: filterItem.label });
                const displayOptions = (filterItem.options || []).map((option) => {
                    if (!option || typeof option !== "object" || option.value == null) {
                        return option;
                    }
                    return {
                        ...option,
                        label: t(`payment.${option.value}`, {
                            defaultValue: t(`status.${String(option.value).toUpperCase()}`, {
                                defaultValue: option.label ?? option.value,
                            }),
                        }),
                    };
                });
              
                return (
                    <Dropdown
                        key={`filterDropDown-${filterItem.label}-${index}`}
                        label={displayLabel}
                        options={displayOptions}
                        selectedOptions={filterItem.selected}
                        multiSelect={filterItem.multiSelect !== false}
                        searchable={filterItem.searchable !== false}
                        isActive={filterItem.isActive}
                        maxSelectedOptions={filterItem.maxSelectedOptions}
                        maxSelectedOptionsMessage={filterItem.maxSelectedOptionsMessage}
                        setIsActive={(e) => {setIsActive(e)}}
                        onSelect={(selected) => {
                            const nextSelected = Array.isArray(selected) ? selected : [selected];
                            onChange({ label: filterItem.label, selected: nextSelected });
                        }}
                    />
                );
            })}
           
            <div className="flex gap-2 justify-end">
                <button className="btn btn-outline-mute" onClick={() => {clearFilter()}} >{t("filter.clearFilter")}</button>
                {allowDeleteDimension &&
                    <button className="btn btn-outline-error" onClick={() => {deleteDimension()}}>{t("filter.removeDimension")}</button>
                }
            </div>
        </div>
    );
};

export default DropdownFilter;
